import React, { useEffect, useState } from 'react';
import { useMatomo } from '@datapunt/matomo-tracker-react'
import { Dialog, DialogContent, DialogTitle, IconButton, Grid, Box, Typography, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ipeImage from '../../../assets/img/IPE.png';
import iegImage from '../../../assets/img/IEG.png';

const STORAGE_KEY = 'sys_new_courses_popup_date';

const COURSES = [
    {
        title: "Iniciando el Pensamiento Estadístico",
        image: ipeImage,
        description: "El curso Iniciando el Pensamiento Estadístico se enfoca en desarrollar los conocimientos matemáticos requeridos para enseñar estadística en los niveles de 1° a 4° básico.",
        dirigido: "Docentes que enseñan matemática en los niveles de 1° a 4° básico.",
        link: "https://ingenieria.uchile.cl/cursos/237105/iniciando-el-pensamiento-estadistico"
    },
    {
        title: "Innovando en la Enseñanza de la Geometría",
        image: iegImage,
        description: "El curso Innovando en la Enseñanza de la Geometría se enfoca en desarrollar los conocimientos matemáticos requeridos para enseñar geometría en los niveles de 7° y 8° básico.",
        dirigido: "Docentes que enseñan matemática en los niveles de 7° y 8° básico.",
        link: "https://ingenieria.uchile.cl/cursos/237104/innovando-en-la-ensenanza-de-la-geometria"
    }
];

const todayKey = () => {
    const now = new Date();
    return `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
};

const CourseColumn = ({ course, onEnroll }) => (
    <Grid item xs={12} md={6} sx={{ display: "flex", flexDirection: "column" }}>
        <Box
            sx={{
                flexGrow: 1,
                border: "2px solid #DDDDDD",
                borderRadius: "16px",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column"
            }}
        >
            <Typography
                sx={{
                    color: "#646464",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: "1.4em",
                    lineHeight: "1.3",
                    padding: "16px 20px 8px 20px",
                }}
            >
                {course.title}
            </Typography>
            <Box sx={{
                height: "220px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "8px 16px"
            }}>
                <Box
                    component="img"
                    sx={{ maxWidth: "100%", maxHeight: "100%" }}
                    alt={course.title}
                    src={course.image}
                />
            </Box>
            <Typography sx={{ color: "#646464", lineHeight: "1.4", textAlign: "justify", padding: "16px 20px", flexGrow: 1 }}>
                {course.description}
            </Typography>
            <Box sx={{ backgroundColor: "#EEEEEE", padding: "16px 20px" }}>
                <Typography sx={{ color: "#646464", lineHeight: "1.4", textAlign: "justify" }}>
                    <b>Dirigido a:</b> {course.dirigido}
                </Typography>
            </Box>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", mt: "16px" }}>
            <Button
                variant="contained"
                href={course.link}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => onEnroll(course.title)}
                sx={{
                    backgroundColor: "#d23831",
                    "&:hover": { backgroundColor: "#a82a25" },
                    fontWeight: "bold"
                }}
            >
                Inscribirse
            </Button>
        </Box>
    </Grid>
);

const NewCoursesPopup = () => {

    const { trackEvent } = useMatomo();

    const [open, setOpen] = useState(false);

    useEffect(() => {
        try {
            const lastShown = window.localStorage.getItem(STORAGE_KEY);
            if (lastShown !== todayKey()) {
                setOpen(true);
                window.localStorage.setItem(STORAGE_KEY, todayKey());
                trackEvent({ category: 'NewCoursesPopup', action: 'Open', name: 'daily' });
            }
        } catch (error) {
            // localStorage unavailable (e.g. private mode); show once for this session.
            setOpen(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = () => {
        trackEvent({ category: 'NewCoursesPopup', action: 'Close', name: 'daily' });
        setOpen(false);
    };

    const handleEnroll = (name) => {
        trackEvent({ category: 'NewCoursesPopup', action: 'Enroll', name });
    };

    return (
        <Dialog
            PaperProps={{ sx: { width: "100%", maxHeight: "90%", padding: "10px 20px", border: "3px solid #d23831", borderRadius: "12px", overflow: "visible" } }}
            open={open}
            onClose={handleClose}
            fullWidth={true}
            maxWidth={"md"}
            aria-labelledby="new-courses-dialog-title"
        >
            <DialogTitle
                id="new-courses-dialog-title"
                sx={{
                    ml: "24px",
                    mt: "24px",
                    p: "12px 0 12px 12px",
                    color: "#d23831",
                    fontFamily: "DIN Bold",
                    fontSize: "1.8em",
                    fontWeight: "bold",
                    textAlign: "left",
                    textTransform: "uppercase",
                    borderLeft: "5px solid #CCCCCC"
                }}
            >
                Nuevos Cursos Disponibles
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: -18,
                    top: -18,
                    backgroundColor: "#d23831",
                    color: "white",
                    width: 44,
                    height: 44,
                    boxShadow: 2,
                    "&:hover": { backgroundColor: "#a82a25" },
                }}
            >
                <CloseIcon sx={{ fontSize: 28 }} />
            </IconButton>
            <DialogContent>
                <Grid container spacing={4} display={"flex"} justifyContent={"center"}>
                    {COURSES.map((course) => (
                        <CourseColumn key={course.title} course={course} onEnroll={handleEnroll} />
                    ))}
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default NewCoursesPopup;
